import { getHomeLink, useSecurityKeys } from '@MGPD/myasurion-shared';
import { Flex, Spinner } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';

import { consumeSSOAuthToken, fetchAccountProfile } from '../services/api';

async function setSessionAndRedirect(data: any) {
    await new Promise((resolve) => {
        sessionStorage.setItem('account', JSON.stringify(data.body));
        console.log('account details saved to session. Redirecting...');
        setTimeout(resolve, 0); // Minimal delay to allow event loop to proceed
    });

    window.location.href = getHomeLink();
}

function SSOConsumer() {
    const { authorization: securityAuthorization, xId } = useSecurityKeys();
    useQuery(
        ['SSOConsumer'],
        async () => {
            const params = new URLSearchParams(window.location.search);
            const c = params.get('c');
            // const accessToken = sessionStorage.getItem('at');
            // const accountInfo = sessionStorage.getItem('account');

            if (!c) {
                // if (!c) {
                console.log('token is missing or invalid ', c);
                window.location.href = '/login';
                return;
            }
            // if (accessToken || accountInfo) {
            //     console.log('access exists ', c);
            //     window.location.href = '/login';
            //     return;
            // }
            console.log('consuming SSO Token ', c);
            return await consumeSSOAuthToken(c, securityAuthorization, xId);
        },
        {
            retry: 5,
            onSuccess: (data) => {
                console.log('SSO token consumed successfully. ', data.body);
                if (data?.statusCode === 200) {
                    sessionStorage.setItem('at', JSON.stringify(data.body));
                    sessionStorage.setItem('data', JSON.stringify(data.body.data));
                    console.log('at is saved to session. Fetching user account...', data.body);
                    refetchUserAccount();
                } else {
                    window.location.href = window.location.origin + '/login';
                }
            },
            onError: (error) => {
                console.error(error);
            },
            enabled: true,
        }
    );

    const { refetch: refetchUserAccount } = useQuery(
        ['userAccount'],
        async () => {
            console.log('Fetching account profile');
            const authTokens = sessionStorage.getItem('at');
            const parsedAuthTokens = authTokens ? JSON.parse(authTokens) : null;
            return await fetchAccountProfile(parsedAuthTokens);
        },
        {
            retry: 5,
            onSuccess: (data) => {
                console.log('Account profile fetched. ', data);
                if (data?.statusCode === 200) {
                    setSessionAndRedirect(data);
                } else {
                    window.location.href = window.location.origin + '/login';
                }
            },
            onError: (error) => {
                console.error(error);
            },
            enabled: false,
        }
    );

    return (
        <Flex
            w={'full'}
            color={'#000'}
            mt={'60px'}
            p={'16px 8px'}
            maxW={{ base: 'initial', lg: '768px', xl: '992px', '2xl': '1280px' }}
            mx={{ base: '0px', lg: 'auto' }}
            flex={1}
            style={{ height: 'calc(100vh - 56px)' }}
        >
            <Flex h="full" w="full" justifyContent="center" alignItems="center">
                <Spinner />
            </Flex>
        </Flex>
    );
}

export default SSOConsumer;
